import Event from './Event';

/**
 *
 * EventDispatcher class
 * EventDispatcher.setAsDispatcher is static method for adding event dispatching methods to a single object, for cases where extension is already set.
 * 
 * @author Reinier Feijen
 * 
 * Wishes: 
 * - set priority in addEventListener
 *
 */

export default class EventDispatcher {
    constructor() {
        this.listeners = {};
    };

    addEventListener(type, listener, scope) {
        //FIXME: in many cases you might scope to be equal to this on the caller
        // automatically, would that be a good default?

        //TODO/WISH: add 4th argument 'priority'
        if (!listener instanceof Function)
            throw { message: "Listener is not a function." };
        if (!this.listeners[type])
            this.listeners[type] = [];
        //TODO? check if this listener+scope is already in our array
        this.listeners[type].push([listener, scope]);
    };

    hasEventListener(type) {
        return (typeof this.listeners[type] !== "undefined");
    };

    removeAllEventListeners() {
        this.listeners = {};
    };

    removeEventListener(type, listener, scope) {
        if (!this.hasEventListener(type))
            return false;
        var l = this.listeners[type];
        for (var i = l.length - 1; i >= 0; i--) {
            if (l[i][0] === listener && l[i][1] === scope)
                l.splice(i, 1);
        }
        if (l.length === 0)
            delete this.listeners[type];
    };

    dispatchEvent(type, data, target) {
        if (!this.hasEventListener(type))
            return false;
        //build event
        var e = new Event(type, data);
        if (target)
            e.target = target;
        else
            e.target = this;
        //
        var l = this.listeners[type];
        for (var i = 0; i < l.length; i++) {
            if (e.cancelled || l[i][0].apply(l[i][1], [e]) === false)
                break;//when event is cancelled or listener return false, stop event 'propagation'
        }
    };

    //Functionality for adding event methods to an object
    //dont add to prototype because this will result in shared listeners property between instances
    static setAsDispatcher(object) {
        if (object.eventDispatcher) {
            console.warn("EventDispatcher.setAsDispatcher, object already has a eventDispatcher: ", object);
            return;
        }
        object.eventDispatcher = new EventDispatcher();
        object.addEventListener = function (type, listener, scope) {
            object.eventDispatcher.addEventListener(type, listener, scope);
        };
        object.hasEventListener = function (type) {
            object.eventDispatcher.hasEventListener(type);
        };
        object.removeEventListener = function (type, listener, scope) {
            object.eventDispatcher.removeEventListener(type, listener, scope);
        };
        object.removeAllEventListeners = function () {
            object.eventDispatcher.removeAllEventListeners();
        };
        object.dispatchEvent = function (type, data) {
            object.eventDispatcher.dispatchEvent(type, data, object);
        };
    };
}